import { currencyFormat, formatNumber, percentNumber } from "@/utils/analyticsUtils"

// 渲染货币格式化函数
export const renderCurrency = (value: string | number, format: string, defaultValue = "-") => {
  return currencyFormat(typeof value === "number" ? String(value) : value, format, defaultValue)
}

// 渲染百分比与数值函数
export const renderValueWithPercent = (value: any, percentage: string | number | null | undefined) => {
  if (value === 0) return "-"
  return `${formatNumber(value)} (${percentNumber(percentage || "-")})`
}

// 格式化配额数量
export const formatQuotaCount = (count: number) => formatNumber(count) 